module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bttn",
    on: {
      "click": _vm.open
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.createroom_button.create_room')))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-54d810de!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateCalendars/CreateRoomsButton.vue
// module id = 1924
// module chunks = 1